<h2 class="credit-history__title">Кредитная история</h2>

<app-loader>
	@if (loader.completed && !clientCreditBureauToken) {
		<a
			class="link link--blacked credit-history__link"
			routerLink="/credit/credit-bureau-apply"
		>
			<div class="credit-history-none">
				<span class="icon-credit-history"></span>
				<span class="get-history">Получение доступа к&nbsp;кредитной истории</span>
			</div>
		</a>
	}

	@if (loader.completed && clientCreditBureauToken) {
		<iframe
			class="credit-history-frame"
			name="creditBureauFrame"
			width="250"
			height="85"
			frameborder="0"
			marginwidth="0"
			marginheight="0"
			allowtransparency="true"
			[src]="clientCreditBureauUrl"
		></iframe>
		<form
			id="creditBureauForm"
			name="creditBureauForm"
			[action]="clientCreditBureauUrl"
			method="post"
			target="creditBureauFrame"
		>
			<input
				name="user-id"
				type="hidden"
				value="1"
			/>
			<input
				name="client-code"
				type="hidden"
				[value]="clientCreditBureauToken"
			/>
		</form>
	}
</app-loader>
